var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-video",style:(`width: ${_vm.width}px; height: ${_vm.height}px;`)},[_c('video-player',{ref:"videoPlayer",staticClass:"vjs-custom-skin",attrs:{"id":"my-video","options":_vm.playerOptions,"poster":_vm.seriesImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }